import React from "react";


export default function CardReview({ name, logo ,jabatan}) {
  return (
    <div className="relative p-10 border sm:mx-3 border-cardText rounded-2xl">
      <div className="flex justify-center">
        <img src={logo} alt="" width={120} height={120} />
      </div>
      <p className="mt-8 text-xl font-bold text-center">{name}</p>
      <p className="mb-8 text-xs italic font-semibold text-center text-primary">{jabatan}</p>
      <p className="mt-10 text-center text-cardText">Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis praesentium corrupti minima quas perspiciatis impedit tempore, repudiandae nostrum voluptate doloremque.</p>
    </div>
  );
}
